/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.206.1-v202610051731-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqUserGroupsApiClass {
 
   constructor() {}

  /**
   * @summary Add a user to a user group
   * @param {string} userGroupId - ID of the user group to add user or user group to
   * @param {string} identityId - ID of the user or user group to add.
  */
  public addIdentityToUserGroup(
    {
      userGroupId,
      identityId
    } : {
      userGroupId: string,
      identityId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (userGroupId === null || userGroupId === undefined) {
      throw new Error("'userGroupId' parameter required");
    }

    if (identityId === null || identityId === undefined) {
      throw new Error("'identityId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups/${encodeURIComponent(String(userGroupId))}/${encodeURIComponent(String(identityId))}`
      .replace('{userGroupId}', encodeURIComponent(String(userGroupId)))
      .replace('{identityId}', encodeURIComponent(String(identityId)));
    const urlTemplate = `${baseUrl}/usergroups/{userGroupId}/{identityId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.UserGroupOutputV1>;
  }

  /**
   * @summary Archive a user group
   * @param {string} userGroupId - ID of user group to archive
   * @param {boolean} [removePermissions=false] - Whether to remove permissions associated with the group being archived
  */
  public archiveUserGroup(
    {
      userGroupId,
      removePermissions
    } : {
      userGroupId: string,
      removePermissions?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (userGroupId === null || userGroupId === undefined) {
      throw new Error("'userGroupId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups/${encodeURIComponent(String(userGroupId))}/archive`
      .replace('{userGroupId}', encodeURIComponent(String(userGroupId)));
    const urlTemplate = `${baseUrl}/usergroups/{userGroupId}/archive`;

    const queryParams = {
      ['removePermissions']: removePermissions
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.UserGroupOutputV1>;
  }

  /**
   * @summary Create a user group hosted within Seeq
  */
  public createUserGroup(
    body: models.UserGroupInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups`;
    const urlTemplate = `${baseUrl}/usergroups`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.UserGroupOutputV1>;
  }

  /**
   * @summary Disable a user group
   * @param {string} userGroupId - ID of user group to disable
   * @param {boolean} [removePermissions=false] - Whether to remove permissions associated with the group being disabled
  */
  public disableUserGroup(
    {
      userGroupId,
      removePermissions
    } : {
      userGroupId: string,
      removePermissions?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (userGroupId === null || userGroupId === undefined) {
      throw new Error("'userGroupId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups/${encodeURIComponent(String(userGroupId))}/disable`
      .replace('{userGroupId}', encodeURIComponent(String(userGroupId)));
    const urlTemplate = `${baseUrl}/usergroups/{userGroupId}/disable`;

    const queryParams = {
      ['removePermissions']: removePermissions
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.UserGroupOutputV1>;
  }

  /**
   * @summary Get the collection of usergroups used to manage capabilities
   * @param {string} [nameSearch] - Search text by which to filter capability groups&#x27; names.
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination level, the total number of collection items that will be returned in this page of results
  */
  public getCapabilityUserGroups(
    {
      nameSearch,
      offset,
      limit
    } : {
      nameSearch?: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups/capabilities`;
    const urlTemplate = `${baseUrl}/usergroups/capabilities`;

    const queryParams = {
      ['nameSearch']: nameSearch,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.IdentityPreviewListV1>;
  }

  /**
   * @summary Get a user group
   * @param {string} userGroupId - ID of the user group to get
   * @param {boolean} [includeMembers=true] - Whether to include members in the output
   * @param {boolean} [includeCapabilities=false] - Whether to include the granted capabilities in the output
  */
  public getUserGroup(
    {
      userGroupId,
      includeMembers,
      includeCapabilities
    } : {
      userGroupId: string,
      includeMembers?: boolean,
      includeCapabilities?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (userGroupId === null || userGroupId === undefined) {
      throw new Error("'userGroupId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups/${encodeURIComponent(String(userGroupId))}`
      .replace('{userGroupId}', encodeURIComponent(String(userGroupId)));
    const urlTemplate = `${baseUrl}/usergroups/{userGroupId}`;

    const queryParams = {
      ['includeMembers']: includeMembers,      ['includeCapabilities']: includeCapabilities
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.UserGroupOutputV1>;
  }

  /**
   * @summary Get a collection of usergroups
   * @param {string} [nameSearch] - Search text by which to filter user groups&#x27; names.
   * @param {string} [datasourceIdSearch] - Search text by which to filter user groups&#x27; directories.
   * @param {boolean} [isEnabled] - Return only user groups that have the specified value for Enabled.
   * @param {string} [sortOrder=name asc] - Sort order for the results. Field must be &#x27;name&#x27; followed by a space and either &#x27;asc&#x27; or &#x27;desc&#x27;, for ascending or descending order
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination level, the total number of collection items that will be returned in this page of results
   * @param {boolean} [includeExternalOrganizationGroups=false] - Whether to include external organization groups in the results. Defaults to false.
  */
  public getUserGroups(
    {
      nameSearch,
      datasourceIdSearch,
      isEnabled,
      sortOrder,
      offset,
      limit,
      includeExternalOrganizationGroups
    } : {
      nameSearch?: string,
      datasourceIdSearch?: string,
      isEnabled?: boolean,
      sortOrder?: string,
      offset?: number,
      limit?: number,
      includeExternalOrganizationGroups?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups`;
    const urlTemplate = `${baseUrl}/usergroups`;

    const queryParams = {
      ['nameSearch']: nameSearch,      ['datasourceIdSearch']: datasourceIdSearch,      ['isEnabled']: isEnabled,      ['sortOrder']: sortOrder,      ['offset']: offset,      ['limit']: limit,      ['includeExternalOrganizationGroups']: includeExternalOrganizationGroups
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.IdentityPreviewListV1>;
  }

  /**
   * @summary Create or update multiple user groups
  */
  public putUserGroups(
    body: models.PutUserGroupsInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups/batch`;
    const urlTemplate = `${baseUrl}/usergroups/batch`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemBatchOutputV1>;
  }

  /**
   * @summary Remove a user from a user group
   * @param {string} userGroupId - ID of the user group to remove user from
   * @param {string} identityId - ID of the user or user group to remove.
  */
  public removeIdentityFromUserGroup(
    {
      userGroupId,
      identityId
    } : {
      userGroupId: string,
      identityId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (userGroupId === null || userGroupId === undefined) {
      throw new Error("'userGroupId' parameter required");
    }

    if (identityId === null || identityId === undefined) {
      throw new Error("'identityId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups/${encodeURIComponent(String(userGroupId))}/${encodeURIComponent(String(identityId))}`
      .replace('{userGroupId}', encodeURIComponent(String(userGroupId)))
      .replace('{identityId}', encodeURIComponent(String(identityId)));
    const urlTemplate = `${baseUrl}/usergroups/{userGroupId}/{identityId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.UserGroupOutputV1>;
  }

  /**
   * @summary Remove a user group
   * @param {string} userGroupId - ID of the user group to remove
  */
  public removeUserGroup(
    {
      userGroupId
    } : {
      userGroupId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (userGroupId === null || userGroupId === undefined) {
      throw new Error("'userGroupId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups/${encodeURIComponent(String(userGroupId))}`
      .replace('{userGroupId}', encodeURIComponent(String(userGroupId)));
    const urlTemplate = `${baseUrl}/usergroups/{userGroupId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Update name or description of a user group
   * @param {string} userGroupId - ID of the user group to update
  */
  public updateUserGroup(
    body: models.UserGroupInputV1,
    {
      userGroupId
    } : {
      userGroupId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (userGroupId === null || userGroupId === undefined) {
      throw new Error("'userGroupId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/usergroups/${encodeURIComponent(String(userGroupId))}`
      .replace('{userGroupId}', encodeURIComponent(String(userGroupId)));
    const urlTemplate = `${baseUrl}/usergroups/{userGroupId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.UserGroupOutputV1>;
  }

}


export const sqUserGroupsApi = new sqUserGroupsApiClass();

export type sqUserGroupsApiEndpoints = {
  'addIdentityToUserGroup': {
    method: 'post';
    path: '/usergroups/${encodeURIComponent(String(userGroupId))}/${encodeURIComponent(String(identityId))}';
    response: models.UserGroupOutputV1;
  };
  'archiveUserGroup': {
    method: 'post';
    path: '/usergroups/${encodeURIComponent(String(userGroupId))}/archive';
    response: models.UserGroupOutputV1;
  };
  'createUserGroup': {
    method: 'post';
    path: '/usergroups';
    response: models.UserGroupOutputV1;
  };
  'disableUserGroup': {
    method: 'post';
    path: '/usergroups/${encodeURIComponent(String(userGroupId))}/disable';
    response: models.UserGroupOutputV1;
  };
  'getCapabilityUserGroups': {
    method: 'get';
    path: '/usergroups/capabilities';
    response: models.IdentityPreviewListV1;
  };
  'getUserGroup': {
    method: 'get';
    path: '/usergroups/${encodeURIComponent(String(userGroupId))}';
    response: models.UserGroupOutputV1;
  };
  'getUserGroups': {
    method: 'get';
    path: '/usergroups';
    response: models.IdentityPreviewListV1;
  };
  'putUserGroups': {
    method: 'post';
    path: '/usergroups/batch';
    response: models.ItemBatchOutputV1;
  };
  'removeIdentityFromUserGroup': {
    method: 'delete';
    path: '/usergroups/${encodeURIComponent(String(userGroupId))}/${encodeURIComponent(String(identityId))}';
    response: models.UserGroupOutputV1;
  };
  'removeUserGroup': {
    method: 'delete';
    path: '/usergroups/${encodeURIComponent(String(userGroupId))}';
    response: models.StatusMessageBase;
  };
  'updateUserGroup': {
    method: 'post';
    path: '/usergroups/${encodeURIComponent(String(userGroupId))}';
    response: models.UserGroupOutputV1;
  };
};

type ApiAddIdentityToUserGroupResponse = models.UserGroupOutputV1;
type ApiaddIdentityToUserGroupMutationParams = Parameters<typeof sqUserGroupsApi.addIdentityToUserGroup> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUserGroupsApi.addIdentityToUserGroup>;

export function useApiAddIdentityToUserGroupMutation(
  options?: Omit<UseMutationOptions<ApiAddIdentityToUserGroupResponse, AxiosError<SeeqErrorData>,
    ApiaddIdentityToUserGroupMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiAddIdentityToUserGroupResponse, AxiosError<SeeqErrorData>,
  ApiaddIdentityToUserGroupMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiaddIdentityToUserGroupMutationParams) =>
      sqUserGroupsApi.addIdentityToUserGroup(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveUserGroupResponse = models.UserGroupOutputV1;
type ApiarchiveUserGroupMutationParams = Parameters<typeof sqUserGroupsApi.archiveUserGroup> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUserGroupsApi.archiveUserGroup>;

export function useApiArchiveUserGroupMutation(
  options?: Omit<UseMutationOptions<ApiArchiveUserGroupResponse, AxiosError<SeeqErrorData>,
    ApiarchiveUserGroupMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveUserGroupResponse, AxiosError<SeeqErrorData>,
  ApiarchiveUserGroupMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveUserGroupMutationParams) =>
      sqUserGroupsApi.archiveUserGroup(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateUserGroupResponse = models.UserGroupOutputV1;
type ApicreateUserGroupMutationParams = Parameters<typeof sqUserGroupsApi.createUserGroup> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUserGroupsApi.createUserGroup>;
type ApicreateUserGroupMutationVariables = models.UserGroupInputV1;

export function useApiCreateUserGroupMutation(
  options?: Omit<UseMutationOptions<ApiCreateUserGroupResponse, AxiosError<SeeqErrorData>,
    ApicreateUserGroupMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateUserGroupResponse, AxiosError<SeeqErrorData>,
  ApicreateUserGroupMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateUserGroupMutationVariables) =>
      sqUserGroupsApi.createUserGroup(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDisableUserGroupResponse = models.UserGroupOutputV1;
type ApidisableUserGroupMutationParams = Parameters<typeof sqUserGroupsApi.disableUserGroup> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUserGroupsApi.disableUserGroup>;

export function useApiDisableUserGroupMutation(
  options?: Omit<UseMutationOptions<ApiDisableUserGroupResponse, AxiosError<SeeqErrorData>,
    ApidisableUserGroupMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDisableUserGroupResponse, AxiosError<SeeqErrorData>,
  ApidisableUserGroupMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApidisableUserGroupMutationParams) =>
      sqUserGroupsApi.disableUserGroup(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetCapabilityUserGroupsResponse = models.IdentityPreviewListV1;
export function GetCapabilityUserGroupsQueryKey(
  params: Parameters<typeof sqUserGroupsApi.getCapabilityUserGroups>[0],
) {
  return ['sqUserGroupsApi', 'getCapabilityUserGroups', params] as const;
}

export function useApiGetCapabilityUserGroupsQuery(
  params: Parameters<typeof sqUserGroupsApi.getCapabilityUserGroups>[0],
  options?: Omit<UseQueryOptions<ApiGetCapabilityUserGroupsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCapabilityUserGroupsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCapabilityUserGroupsQueryKey(params),
    queryFn: () =>
      sqUserGroupsApi.getCapabilityUserGroups(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetUserGroupResponse = models.UserGroupOutputV1;
export function GetUserGroupQueryKey(
  params: Parameters<typeof sqUserGroupsApi.getUserGroup>[0],
) {
  return ['sqUserGroupsApi', 'getUserGroup', params] as const;
}

export function useApiGetUserGroupQuery(
  params: Parameters<typeof sqUserGroupsApi.getUserGroup>[0],
  options?: Omit<UseQueryOptions<ApiGetUserGroupResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetUserGroupResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetUserGroupQueryKey(params),
    queryFn: () =>
      sqUserGroupsApi.getUserGroup(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetUserGroupsResponse = models.IdentityPreviewListV1;
export function GetUserGroupsQueryKey(
  params: Parameters<typeof sqUserGroupsApi.getUserGroups>[0],
) {
  return ['sqUserGroupsApi', 'getUserGroups', params] as const;
}

export function useApiGetUserGroupsQuery(
  params: Parameters<typeof sqUserGroupsApi.getUserGroups>[0],
  options?: Omit<UseQueryOptions<ApiGetUserGroupsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetUserGroupsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetUserGroupsQueryKey(params),
    queryFn: () =>
      sqUserGroupsApi.getUserGroups(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPutUserGroupsResponse = models.ItemBatchOutputV1;
type ApiputUserGroupsMutationParams = Parameters<typeof sqUserGroupsApi.putUserGroups> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUserGroupsApi.putUserGroups>;
type ApiputUserGroupsMutationVariables = models.PutUserGroupsInputV1;

export function useApiPutUserGroupsMutation(
  options?: Omit<UseMutationOptions<ApiPutUserGroupsResponse, AxiosError<SeeqErrorData>,
    ApiputUserGroupsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPutUserGroupsResponse, AxiosError<SeeqErrorData>,
  ApiputUserGroupsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApiputUserGroupsMutationVariables) =>
      sqUserGroupsApi.putUserGroups(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiRemoveIdentityFromUserGroupResponse = models.UserGroupOutputV1;
type ApiremoveIdentityFromUserGroupMutationParams = Parameters<typeof sqUserGroupsApi.removeIdentityFromUserGroup> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUserGroupsApi.removeIdentityFromUserGroup>;

export function useApiRemoveIdentityFromUserGroupMutation(
  options?: Omit<UseMutationOptions<ApiRemoveIdentityFromUserGroupResponse, AxiosError<SeeqErrorData>,
    ApiremoveIdentityFromUserGroupMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRemoveIdentityFromUserGroupResponse, AxiosError<SeeqErrorData>,
  ApiremoveIdentityFromUserGroupMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiremoveIdentityFromUserGroupMutationParams) =>
      sqUserGroupsApi.removeIdentityFromUserGroup(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRemoveUserGroupResponse = models.StatusMessageBase;
type ApiremoveUserGroupMutationParams = Parameters<typeof sqUserGroupsApi.removeUserGroup> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUserGroupsApi.removeUserGroup>;

export function useApiRemoveUserGroupMutation(
  options?: Omit<UseMutationOptions<ApiRemoveUserGroupResponse, AxiosError<SeeqErrorData>,
    ApiremoveUserGroupMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRemoveUserGroupResponse, AxiosError<SeeqErrorData>,
  ApiremoveUserGroupMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiremoveUserGroupMutationParams) =>
      sqUserGroupsApi.removeUserGroup(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateUserGroupResponse = models.UserGroupOutputV1;
type ApiupdateUserGroupMutationParams = Parameters<typeof sqUserGroupsApi.updateUserGroup> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUserGroupsApi.updateUserGroup>;

export function useApiUpdateUserGroupMutation(
  options?: Omit<UseMutationOptions<ApiUpdateUserGroupResponse, AxiosError<SeeqErrorData>,
    ApiupdateUserGroupMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateUserGroupResponse, AxiosError<SeeqErrorData>,
  ApiupdateUserGroupMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateUserGroupMutationParams) =>
      sqUserGroupsApi.updateUserGroup(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
